import DapDSCardSubtitle from './card-subtitle.component'

export * from './card-subtitle.component'
export default DapDSCardSubtitle

DapDSCardSubtitle.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-card-subtitle': DapDSCardSubtitle
  }
}
